import { Button } from "@/components/ui/button";
const heroImg = "/hero-box.jpg";

export default function HeroSection() {
  const scrollTo = (id: string) => {
    document.querySelector(id)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section className="relative min-h-[90vh] flex items-center justify-center overflow-hidden">
      {/* Background image */}
      <div className="absolute inset-0">
        <img src={heroImg} alt="Box CrossFit Chistera à Saint-Pierre-de-Chandieu — salle d'entraînement équipée pour le CrossFit, l'haltérophilie et l'Hybrid Training" width={900} height={1260} {...({ fetchpriority: "high" } as any)} decoding="async" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-charcoal/85" />
      </div>

      {/* Content */}
      <div className="relative z-10 text-center px-4 max-w-3xl mx-auto">
        <h1 className="text-5xl md:text-7xl lg:text-8xl text-white leading-[0.95] mb-6">
          <span className="sr-only">CrossFit Chistera — Box de CrossFit affiliée à Saint-Pierre-de-Chandieu (Lyon Est, Rhône). </span>
          <span aria-hidden="true">Repousse tes limites<br /><span className="text-gold">À ton rythme</span></span>
        </h1>
        <p className="text-lg md:text-xl text-white/80 mb-8 font-body normal-case max-w-xl mx-auto">
          Cours collectifs coachés, adaptés à tous les niveaux<br />
          Rejoins une communauté motivante et bienveillante
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Button
            size="lg"
            onClick={() => scrollTo("#contact")}
            className="bg-cta text-cta-foreground hover:bg-cta/90 text-base px-8 py-6 rounded-lg font-semibold"
          >
            Je réserve mon essai gratuit
          </Button>
          <Button
            size="lg"
            onClick={() => scrollTo("#crossfit")}
            className="bg-white text-gold border-2 border-gold hover:bg-gold hover:text-charcoal text-base px-8 py-6 rounded-lg font-semibold"
          >
            Découvrir le CrossFit
          </Button>
        </div>
      </div>
    </section>
  );
}
